import { render, staticRenderFns } from "./ItsStockPrecoolMaterInBoundDetail.vue?vue&type=template&id=decc174a&scoped=true&"
import script from "./ItsStockPrecoolMaterInBoundDetail.vue?vue&type=script&lang=js&"
export * from "./ItsStockPrecoolMaterInBoundDetail.vue?vue&type=script&lang=js&"
import style0 from "./ItsStockPrecoolMaterInBoundDetail.vue?vue&type=style&index=0&id=decc174a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "decc174a",
  null
  
)

export default component.exports